<template>
  <div>
    <hr v-if="showDivider" class="bg-stone-200 my-4" />
    <div class="bg-stone-50 rounded-lg p-3">
      <p class="text-xs text-gray-900 mb-1.5">
        {{ t('review.partnerReply.label') }}
      </p>
      <p v-if="expanded" class="text-xs text-gray-500" v-html="reply" />
      <ReadMore
        v-else
        :content="reply"
        :max-chars="200"
        :prevent-expand="openSidebarOnReadMore"
        class="text xs text-gray-500"
        @toggle="onReadMoreToggle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  reply: string
  openSidebarOnReadMore?: boolean
  showDivider?: boolean
  expanded?: boolean
}>()

const showDivider = computed(() => props.showDivider ?? true)

const emit = defineEmits<{
  (e: 'expand'): void
}>()

const { t } = useI18n()

const onReadMoreToggle = () => {
  if (props.openSidebarOnReadMore) {
    emit('expand')
  }
}
</script>
